module.exports = __webpack_public_path__ + "static/portrait01-b0be09adfc2f5289947dd50ecde6a153.png";